module.exports = __webpack_public_path__ + "img/header.ac790f98.png";